import { createReducer } from "../../../common/reduxUtil";
import { GMAT_SET_MOCK_SHOP } from "./types";

const initialState = {
  mockShop: null,
};

export default createReducer(initialState, {
  [GMAT_SET_MOCK_SHOP]: (state, mockShop) => ({ ...state, mockShop }),
});
